import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ShareDataService {
private _data: string = '';
  constructor() { }
  setData(data: string){
    this._data = data;
  }

  getData(): string{
    return this._data;
  }

  clearData(){
    this._data = '';
  }
}
